import { axiosInstance } from "../../config/axios";
import { AxiosError } from "axios";
import { useMutation } from "react-query";
import { BaseResponse } from "../_types";

export interface ProductGroupDetail {
  id: number;
  name: string;
  merchantId: number;
  status: "ACTIVE" | "PASSIVE" | "FAIL" | "PENDING" | "VOID" | "START" | "SUCCESS" | "REFUND" | "EXPIRED" | "BLOCKED" | "DELETED" | "BLACKLISTED";
  systemDate: string;
  createDate: string;
  createUserId: number;
  updateDate: string | null;
  updateUserId: number;
  deleteDate: string | null;
  deleteUserId: number;
}

export type GetProductGroupDetailResponse = BaseResponse<ProductGroupDetail>;

async function getProductGroupDetail(id: number): Promise<GetProductGroupDetailResponse> {
  try {
    return (await axiosInstance.get(`/Product/GetProductGroup?id=${id}`)).data;
  } catch (ex) {
    throw ((ex as AxiosError).response?.data as any).error;
  }
}

export function useGetProductGroupDetail() {
  return useMutation<GetProductGroupDetailResponse, Error, number>(
    (id) => getProductGroupDetail(id)
  );
}
